import { graphql } from '@api/mesa'

export const GET_CARD_APPLICATION_SUBMISSION_SCREEN = graphql(`
  query GetApplicationSubmissionScreen {
    getApplicationSubmissionScreen
  }
`)

export const GET_CARD_APPLICATION_STATUS = graphql(`
  query GetCardProductApplicationStatus {
    getCardProductApplicationStatus {
      paymentCardId
      status
    }
  }
`)
